module.exports = __webpack_public_path__ + "img/engravingOnTheSide.e4f18de.webp";